import { render, staticRenderFns } from "./funnels.vue?vue&type=template&id=3e21c255"
import script from "./funnels.vue?vue&type=script&lang=js"
export * from "./funnels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports